import _ from 'lodash';

import { FILTER_MODES } from './constants';

const matchesFilter = (cellValue, filterValue, filterMode) => {
  if (_.isNil(cellValue)) {
    return false;
  }

  const normalizedCell = String(cellValue).toLowerCase();
  const normalizedFilter = filterValue.toLowerCase();

  switch (filterMode) {
    case FILTER_MODES.EQUALS:
      return normalizedCell === normalizedFilter;
    case FILTER_MODES.STARTS_WITH:
      return normalizedCell.startsWith(normalizedFilter);
    case FILTER_MODES.ENDS_WITH:
      return normalizedCell.endsWith(normalizedFilter);
    case FILTER_MODES.CONTAINS:
    default:
      return normalizedCell.includes(normalizedFilter);
  }
};

const hasActiveFilter = ([, filterState]) => !!filterState?.value || !!filterState?.values?.length;

export const applyColumnFilters = (data, columnFilters, config) => {
  if (!data?.length || _.isNil(columnFilters)) {
    return data;
  }

  const activeFilters = Object.entries(columnFilters).filter(hasActiveFilter);

  if (!activeFilters.length) {
    return data;
  }

  return data.filter(row =>
    activeFilters.every(([key, filterState]) => {
      const columnConfig = config[key];
      const cellValue = columnConfig?.filterAccessor ? columnConfig.filterAccessor(row) : row[key];

      if (filterState.values) {
        if (_.isNil(cellValue)) {
          return false;
        }

        return filterState.values.includes(String(cellValue));
      }

      return matchesFilter(cellValue, filterState.value, filterState.mode);
    }),
  );
};
